/* eslint-disable no-return-assign */
import * as buildEnvs from '../../../_envs.json';
import { ERRORS } from './constants';

const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || 'production';
const ratesUrl = process.env.RATES_API || buildEnvs[activeEnv]?.RATES_API || 'https://www.lowermybills.com/api/quickenloans/rates'

export const mortgageRateAPI = async (productCodes, options) =>
{
    let data = null;

    if (typeof window !== 'undefined' && window.fetch && productCodes?.length)
    {
        const response = await fetch(`${ratesUrl}?loanPurpose=Purchase`, { ...options });
        const responseData = await response.json();

        if (!response.ok) throw new Error(`mortgageRateAPI Error. Response Status: ${response?.status}`, { cause: response })

        const productHashMap = {};
        const productRates = responseData?.productRates
            // filter by productCodes
            ?.filter(({ metadata }) =>
                productCodes.includes(metadata.productCode)
            )
            // filter by first product
            .filter(({ metadata }) =>
            Object.prototype.hasOwnProperty.call(
                productHashMap,
                metadata.productCode
            )
                ? false
                : (productHashMap[metadata.productCode] = true)
            );

        if (!productRates || !productRates?.length) throw new Error(`mortgageRateAPI Error. No Products found: ${productRates}`, { cause: ERRORS.PRODUCTS_NOT_FOUND })

        data = {
            ...responseData,
            productRates
        }
    }


    return data
}
